// AUTO-GENERATED by scripts/fetch-ssg-data.mjs — do not edit.
export interface SsgHomeResult {
    date: string; gameNumber: string; group: string; time: string;
    homeTeam: string; homePK: number; homeScore: string; awayScore: string;
    awayPK: number; awayTeam: string; venue: string; category: string;
}
export const ssgHomeSnapshot: { updatedAt: string | null; results: SsgHomeResult[] } =
    {
    "updatedAt": "2026-10-06T12:19:56.085Z",
    "results": [
        {
            "date": "2024-05-04T16:00:00.000Z",
            "gameNumber": "3",
            "group": "SF",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "惠來國小",
            "homePK": 0,
            "homeScore": "1",
            "awayScore": "7",
            "awayPK": 0,
            "awayTeam": "黎明國小",
            "venue": "西屯 A",
            "category": "高年級女生組"
        },
        {
            "date": "2024-05-04T16:00:00.000Z",
            "gameNumber": "4",
            "group": "SF",
            "time": "1899-12-30T00:23:18.000Z",
            "homeTeam": "南屯國小",
            "homePK": 0,
            "homeScore": "10",
            "awayScore": "1",
            "awayPK": 0,
            "awayTeam": "惠文獵豹",
            "venue": "西屯 B",
            "category": "高年級女生組"
        },
        {
            "date": "2024-05-04T16:00:00.000Z",
            "gameNumber": "5",
            "group": "3rd",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "惠文獵豹",
            "homePK": 0,
            "homeScore": "0",
            "awayScore": "1",
            "awayPK": 0,
            "awayTeam": "惠來國小",
            "venue": "西屯 A",
            "category": "高年級女生組"
        },
        {
            "date": "2024-05-04T16:00:00.000Z",
            "gameNumber": "6",
            "group": "FINAL",
            "time": "1899-12-30T05:23:18.000Z",
            "homeTeam": "南屯國小",
            "homePK": 0,
            "homeScore": "7",
            "awayScore": "2",
            "awayPK": 0,
            "awayTeam": "黎明國小",
            "venue": "西屯 B",
            "category": "高年級女生組"
        },
        {
            "date": "2024-04-29T16:00:00.000Z",
            "gameNumber": "12",
            "group": "F",
            "time": "1899-12-30T01:23:18.000Z",
            "homeTeam": "安和國中",
            "homePK": 0,
            "homeScore": "5",
            "awayScore": "1",
            "awayPK": 0,
            "awayTeam": "崇倫國中",
            "venue": "崇倫 A",
            "category": "學校國中組"
        }
    ]
};
